import { defineComponent, computed, watch, onMounted, onUnmounted } from "vue";
import DeviceSelect from "./DeviceSelect.vue.mjs";
import VideoProfile from "./VideoProfile.vue.mjs";
import TuiSwitch from "./base/TuiSwitch.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { useI18n } from "../../locales/index.mjs";
import useGetRoomEngine from "../../hooks/useRoomEngine.mjs";
import { TRTCVideoMirrorType, TRTCVideoRotation, TRTCVideoFillMode } from "@tencentcloud/tuiroom-engine-js";
import { isMobile, isElectron } from "../../utils/environment.mjs";
import { storeToRefs } from "pinia";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "VideoSettingTab",
  props: {
    withPreview: { type: Boolean },
    withMore: { type: Boolean },
    withMirror: { type: Boolean },
    theme: null
  },
  setup(__props) {
    const props = __props;
    const roomEngine = useGetRoomEngine();
    const basicStore = useBasicStore();
    const { isLocalStreamMirror } = storeToRefs(basicStore);
    const themeClass = computed(
      () => props.theme ? `tui-theme-${props.theme}` : ""
    );
    watch(isLocalStreamMirror, async (val) => {
      var _a;
      const trtcCloud = (_a = roomEngine.instance) == null ? void 0 : _a.getTRTCCloud();
      if (!isMobile) {
        await (trtcCloud == null ? void 0 : trtcCloud.setLocalRenderParams({
          mirrorType: val ? TRTCVideoMirrorType.TRTCVideoMirrorType_Enable : TRTCVideoMirrorType.TRTCVideoMirrorType_Disable,
          rotation: TRTCVideoRotation.TRTCVideoRotation0,
          fillMode: TRTCVideoFillMode.TRTCVideoFillMode_Fill
        }));
      }
    });
    const { t } = useI18n();
    function handleMoreCameraSetting() {
      basicStore.setShowSettingDialog(true);
      basicStore.setActiveSettingTab("video");
    }
    if (props.withPreview) {
      onMounted(async () => {
        var _a, _b;
        (_a = roomEngine.instance) == null ? void 0 : _a.startCameraDeviceTest({ view: "test-camera-preview" });
        if (isElectron) {
          const trtcCloud = (_b = roomEngine.instance) == null ? void 0 : _b.getTRTCCloud();
          await (trtcCloud == null ? void 0 : trtcCloud.setLocalRenderParams({
            mirrorType: isLocalStreamMirror.value ? TRTCVideoMirrorType.TRTCVideoMirrorType_Enable : TRTCVideoMirrorType.TRTCVideoMirrorType_Disable,
            rotation: TRTCVideoRotation.TRTCVideoRotation0,
            fillMode: TRTCVideoFillMode.TRTCVideoFillMode_Fill
          }));
        }
      });
      onUnmounted(() => {
        var _a;
        (_a = roomEngine.instance) == null ? void 0 : _a.stopCameraDeviceTest();
      });
    }
    return { __sfc: true, roomEngine, props, basicStore, isLocalStreamMirror, themeClass, t, handleMoreCameraSetting, DeviceSelect, VideoProfile, TuiSwitch };
  }
});
export {
  _sfc_main as default
};
